import { apiV1 } from './api';

const getConfig = () => apiV1.get(`/configurations`).then(({ data }) => data);

export const configAPI = {
  getConfig,
};
